import { Avatar, Box, Stack, Typography, alpha, useTheme } from '@mui/material'
import { FC } from 'react'
import { useAppSelector } from '../../redux-store/hooks'

const AppLauncher: FC = () => {
  const theme = useTheme()
  const auth = useAppSelector((state) => state.authentication)
  const client = useAppSelector((state) => state.clientInfo.data)

  return (
    <Box
      sx={{
        minHeight: '100%',
        display: 'grid',
        placeItems: 'center',
        px: { xs: 2.5, md: 6 },
        py: { xs: 4, md: 7 },
        position: 'relative',
        overflow: 'hidden',
        bgcolor: theme.palette.background.default,
        background:
          theme.palette.mode === 'dark'
            ? 'radial-gradient(circle at 20% 10%, rgba(212, 175, 55, 0.16), transparent 32%), radial-gradient(circle at 80% 80%, rgba(76, 175, 160, 0.12), transparent 30%)'
            : 'radial-gradient(circle at 18% 12%, rgba(212, 175, 55, 0.22), transparent 34%), radial-gradient(circle at 82% 78%, rgba(58, 123, 213, 0.12), transparent 30%)',
      }}
    >
      <Box
        sx={{
          width: 'min(860px, 100%)',
          borderRadius: 4,
          p: { xs: 3, md: 6 },
          textAlign: 'center',
          border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.16 : 0.62)}`,
          backgroundColor: alpha(theme.palette.background.paper, theme.palette.mode === 'dark' ? 0.62 : 0.72),
          backdropFilter: 'blur(26px) saturate(170%)',
          boxShadow:
            theme.palette.mode === 'dark'
              ? '0 28px 90px rgba(0, 0, 0, 0.38)'
              : '0 28px 90px rgba(15, 23, 42, 0.14)',
        }}
      >
        <Stack alignItems="center" spacing={2.5}>
          <Avatar
            src={client?.clientLogo}
            sx={{
              width: { xs: 86, md: 112 },
              height: { xs: 86, md: 112 },
              borderRadius: 3,
              bgcolor: alpha(theme.palette.common.white, 0.45),
              boxShadow: `0 18px 50px ${alpha('#d4af37', 0.28)}`,
            }}
          />
          <Box>
            <Typography
              variant="overline"
              sx={{
                color: '#b99120',
                fontWeight: 900,
                letterSpacing: 2,
              }}
            >
              {client?.clientName || 'Billdesk'}
            </Typography>
            <Typography
              variant="h3"
              sx={{
                mt: 1,
                color: 'text.primary',
                fontWeight: 900,
                fontSize: { xs: '2rem', md: '3rem' },
              }}
            >
              Welcome back{auth?.username ? `, ${auth.username}` : ''}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mt: 1.5,
                color: 'text.secondary',
                fontWeight: 500,
              }}
            >
              Your workspace is ready.
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Box>
  )
}

export { AppLauncher }
